<div class="flex-box-manage-user">
	<span class="icon-accept">
		<mat-icon *ngIf="isAdminAndDeligationCheck(params)" svgIcon="md:check" (click)="accpetUser(params)"></mat-icon>
	</span>
	<span class="icon-delete">
		<mat-icon *ngIf="isAdmin()" svgIcon="delete_bin" (click)="showDeletionDialog(params)"></mat-icon>
	</span>     
</div>
